<template>
  <div class="password">
    <div class="headertop flex">
      <span style="flex:8;font-size:1.6rem;color:#2bae85;  font-weight: 700;">云上初阳统一登录认证平台</span>
      <span style="float: right;flex:2">
        <router-link to="/registered"
                     class="link"
                     style=" margin-right: 0.3rem;">注册</router-link>|
        <router-link to="/login"
                     class="link"
                     style="margin-left:0.3rem">登录</router-link>
      </span>
    </div>
    <div class="center flex">
      <div class="Modify">
        <p>忘记密码<img src="../../assets/imges/笔 (2)(1).png"
               alt=""></p>
        <hr>
        <ul>
          <li style="margin-top:1rem">
            <img src="../../assets/imges/五角星(1).png"
                 alt=""><span>填写账号:</span>
            <el-input v-model="forget.User_Phone"
                      placeholder="请输入内容"></el-input>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png"
                 alt=""><span>验证码:</span>
            <el-input v-model="forget.code"
                      placeholder="请输入内容"></el-input>
            <el-button @click="validation"
                       style="width:5rem;padding:5px 0 5px 0;"
                       size="mini">发送验证码</el-button>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png"
                 alt=""><span>新密码:</span>
            <el-input show-password v-model="forget.password"
                      placeholder="请输入内容"></el-input>

          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png"
                 alt=""><span>确认密码:</span>
            <el-input show-password v-model="password"
                      placeholder="请输入内容"></el-input>
          </li>
          <li style="margin-left:20%">
            <el-button type="warning"
                       @click="determine"><i>确认修改</i></el-button>
          </li>
        </ul>
      </div>

    </div>
    <div class="bottom ">
      <p>云上初阳</p>
      <div class="flex">
        <ul style="flex:1">
          <li>业务经理:彭易权</li>
          <li>联系电话:0755-23080620</li>
          <li>手机号码:18129846935</li>
          <li>联系 Q Q:574039568</li>
        </ul>
        <ul style="flex:1">
          <li>业务专员:陈泰先</li>
          <li>联系电话: <span>0755-23080620</span> </li>
          <li>手机号码:13129338939</li>
          <li>联系 Q Q: <span>1025203743</span> </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      password: '', //确认密码
      // 忘记密码表单
      forget: {
        User_Phone: '',
        code: '',
        password: ''
      }
    }
  },
  methods: {
    async validation() {
      if (this.$min.validation(3, this.forget.User_Phone)) {
        await this.$http
          .post('UserService.asmx/CheckPhone', {
            User_Phone: this.forget.User_Phone
          })
          .then(res => {
            //   是否注册
            console.log(res)
            if (this.$x2js.xml2js(res.data.d).NewDataSet.ds.type == 'true') {
              // 验证码发送
              this.$axios
                .post('UserService.asmx/SendSmsFindPwd', {
                  User_Phone: this.forget.User_Phone
                })
                .then(res => {
                  if (
                    this.$x2js.xml2js(res.data.d).NewDataSet.ds.type == 'true'
                  ) {
                    this.$message.success('验证码！发送成功！！！')
                  } else {
                    this, $message.error('验证码！发送失败！！！')
                  }
                })
                .catch(res => {
                  this.$message.error(
                    '尊敬的用户请不要在短时间内发送验证码！！'
                  )
                })
            } else {
              this.$message.error('该用户未注册！！！')
            }
          })
          .catch(res => {
            console.log(res)
          })
      } else {
        this.$alert('尊敬的用户您的手机号格式不正确', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${action}`
            })
          }
        })
      }
    },
    // 确认找回
    async determine() {
      let this_ = this
      if (this_.$min.validation(3, this.forget.User_Phone)) {
        if (this_.$min.validation(1, this_.forget.code)) {
          console.log(this_.$min.validation(1, this_.forget.code))
          if (this_.forget.password == this_.password) {
            await this_.$axios
              .post('UserService.asmx/CheckFindPwd', {
                User_Phone: this.forget.User_Phone,
                code: this.forget.code
              })
              .then(res => {
                if (
                  this_.$x2js.xml2js(res.data.d).NewDataSet.ds.type == 'true'
                ) {
                  
                this_.$axios
                    .post('UserService.asmx/UpdatePwd', {
                      User_Phone: this_.forget.User_Phone,
                      User_Pwd: this_.forget.password
                    })
                    .then(res => {
                       
                      if (
                        this_.$x2js.xml2js(res.data.d).NewDataSet.ds.type ==
                        'true'
                      ) {
                        this_.$message.success('密码修改成功！！')
                        this_.$router.push({ path: '/' })
                      } else {
                        this.$alert('尊敬的您的密码找回失败！！', '温馨提示', {
                          confirmButtonText: '确定',
                          callback: action => {
                            this.$message({
                              type: 'info',
                              message: `action: ${action}`
                            })
                          }
                        })
                      }
                    })
                    .catch(res => {
                      console.log(res)
                    })
                } else {
                  this.$alert(
                    '尊敬的您的验证码合手机号不一致！！',
                    '温馨提示',
                    {
                      confirmButtonText: '确定',
                      callback: action => {
                        this.$message({
                          type: 'info',
                          message: `action: ${action}`
                        })
                      }
                    }
                  )
                }
              })
              .catch(res => {
                console.log(res)
              })
          } else {
            this.$alert('尊敬的用户您两次密码输入不一致', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `action: ${action}`
                })
              }
            })
          }
        } else {
          this.$alert('尊敬的用户您的验证码格式不正确', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${action}`
              })
            }
          })
        }
      } else {
        this.$alert('尊敬的用户您的手机号格式不正确', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${action}`
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.password {
  // 底部样式
  .bottom {
    margin: auto;
    width: 100%;
    background-color: #fafafa;
    text-align: center;
    padding-bottom: 1rem;
    position: fixed;
    bottom: 0;
    p {
      font-size: 1.5rem;
      color: #2bae85;
      font-weight: 600;
      margin-top: 1rem;
    }
    .flex {
      width: 350px;
      margin: auto;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
      ul {
        width: 50%;
        li:hover {
          color: #2bae85;
        }
        li {
          text-align: left;
          font-size: 0.8rem;
        }
      }
    }
  }
  // 头部样式
  .headertop {
    width: 60%;
    margin: auto;
    height: 100px;
    align-items: center;
    justify-content: center;
    background-color: #ffff;
    span {
      .link {
        color: #6f6f6f;
      }
      .link:hover {
        color: #2bae85;
      }
    }
  }
  // 中间样式
  .center {
    height: 35rem;
    background-color: #2bae85;
    width: 100%;
    justify-content: center;
    align-items: center;
    ul {
      margin: auto;
      text-align: left;
      margin-left: 10rem;
      li {
        height: 4rem;
        span {
          text-align-last: justify;
          display: inline-block;
          width: 90px;
          font-size: 0.9rem;
        }
        .el-button {
          width: 150px;

          i {
            font-style: unset;
            font-size: 1rem;
            text-align: center;
          }
        }
        .el-input {
          width: 200px;
        }
        img {
          padding-top: 0.2rem;
          width: 1rem;
        }
      }
    }
    .Modify {
      border: 0.1rem solid #dddddd;
      height: 25rem;
      width: 40%;
      background-color: #f8f8f8;
      border-radius: 0.3rem;
      hr {
        padding-top: 0.2rem;
        background-color: #dedede;
      }
      p {
        font-size: 1.5rem;
        color: #6f6f6f;
        padding-left: 0.8rem;
        padding-bottom: 0.5rem;
        img {
          width: 1rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/ChildComponents/ForgotPassword.vue